<template>
    <div class="wrapper-editor-text mt-5">
        <v-divider class="mb-5"></v-divider>
        <div class="title mb-3">
            <v-icon>file_copy</v-icon>
            {{ $t('contracts.form.fileUpload.title') }}
        </div>
        <v-row v-if="filePreview" class="d-flex justify-start">
            <v-col cols="12">
                <contract-file-info :file="value.file" :type="'observation'" :clearFile="clearFile"/>
            </v-col>
        </v-row>
        <div v-else class="mb-5 text-center">
            <v-card
                class="d-flex align-center justify-center"
                :class="{'drag-over': isDragging}"
                @dragover.prevent="onDragOver"
                @dragleave.prevent="onDragLeave"
                @drop.prevent="onDrop"
                outlined
            >
                <v-card-text class="pa-4 align-center justify-center">
                    <v-icon large>mdi-upload</v-icon>
                    <div class="pa-4 d-flex flex-column align-center justify-center">
                        <span class="ma-1" style="color: red">{{ $t('contracts.form.fileUpload.empty') }}</span>
                        <span class="ma-1">{{ $t('contracts.form.fileUpload.tip') }}</span>
                        <v-btn
                            class="ma-1"
                            color="purple"
                            dark
                            @click="triggerFileInput"
                        >{{ $t('contracts.form.fileUpload.action') }}</v-btn>
                        <input
                            type="file"
                            ref="fileInput"
                            class="d-none"
                            @change="onFileChange"
                        />
                    </div>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script>
import ContractFileInfo from '@/components/contract/ContractFileInfo'

export default {
    name: 'contract-object',
    components: {
        ContractFileInfo
    },
    props: ['value', 'form'],
    data () {
        return {
            comment: null,
            filePreview: false,
            files: [],
            isDragging: false
        }
    },
    watch: {
        value () {
            this.filePreview = !!(this.value.file)
        }
    },
    methods: {
        async addFile (event) {
            for (let i = 0; event.target.files.length > i; i++) {
                const file = event.target.files[i]
                const tempFile = file.slice(0, file.size)
                const newFile = new File([tempFile], file.name.replace(/[^a-zA-Z._0-9]/g, ''))
                this.form.changeFile = true
                this.filePreview = true
                this.value.file = newFile
            }
        },
        clearFile () {
            this.form.changeFile = true
            this.filePreview = false
            this.value.file = undefined
        },
        onDragOver (event) {
            this.isDragging = true
        },
        onDragLeave (event) {
            this.isDragging = false
        },
        onDrop (event) {
            event.target.files = event.dataTransfer.files
            this.isDragging = false
            this.addFile(event)
        },
        onFileChange (event) {
            this.addFile(event)
        },
        removeFile (index) {
            this.files.splice(index, 1)
        },
        triggerFileInput () {
            this.$refs.fileInput.click()
        }
    }
}
</script>

<style lang="sass" scoped>
    .theme--light.v-card.v-card--outlined.drag-over
        border: 1px dashed #1976d2
</style>
